import { Component, OnInit,ViewChild, TemplateRef, Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser'
import {DefaultcontactusComponent} from './defaultcontactus/defaultcontactus.component'
import {ElementRef,ViewContainerRef,ComponentFactoryResolver } from '@angular/core';
import { UserService } from '../../shared'
import { environment } from '../../shared/config/app-config';

@Pipe({ name: 'safeHtml'})
export class SafeHtmltestPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(style) {
    return this.sanitized.bypassSecurityTrustHtml(style);
  }
}
@Component({
  selector: 'app-contactme',
  templateUrl: './contactme.component.html',
  styleUrls: ['./contactme.component.css']
})
export class ContactmeComponent implements OnInit {
  @ViewChild('div') div:ElementRef;
  contactusDefaultType:boolean = false;
  test:string;
  constructor(private userService:UserService) { 
  }
  showloader:any;
  public imageURL:string;

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUserData = userData;

        if(this.currentUserData.item){
          if(this.currentUserData.item.hostModel=="CLOUD")
              this.imageURL = environment.cloudeImageURL;
          else   
              this.imageURL = environment.vmImageURL;
         }else   
         this.imageURL = environment.cloudeImageURL;
     }
    )
   this.getUserClientDetails();
 }

  currentUserData:any;
  contactData:any;
  contactusTemplate:string="";
  getUserClientDetails()
  {    
    this.userService.getContactMeClientDetailsID(atob(window.localStorage.getItem('WFD')))
    .subscribe(
      data => {
        this.contactData = data;
        if(this.contactData.contacttype==2)
          this.getCustomContact();
        else
          this.contactusDefaultType = true;
      }
    )
  }

  getCustomContact()
  {
    this.userService.getContactMeTemplate(this.currentUserData.item.userAccountKey)
    .subscribe(
      data => {
        this.contactusTemplate = data.text;
        this.contactusDefaultType=false;
        this.replaceAllVariableInTemplate();
      }
    )
  }
  
  replaceAllVariableInTemplate()
  {
    this.contactusTemplate =  this.contactusTemplate.replace("{{name}}",this.contactData.name).replace("{{address1}}",this.contactData.address1).replace("{{address2}}",this.contactData.address2).replace("{{city}}",this.contactData.city).replace("{{state}}",this.contactData.state).replace("{{zipcode}}",this.contactData.zipcode).replace("{{phone}}",this.contactData.phone).replace("{{email}}",this.contactData.email).replace("{{imageURL}}",this.imageURL).replace("{{backdropImage}}",this.contactData.backdropImage);
    this.contactusTemplate = this.contactusTemplate.replace("{{email}}",this.contactData.email)
  }
}



/*  this.contactusTemplate = `<html><head><style></style></head><body><div>
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12 text-center">
              <img src="/assets/img/bg_img.jpg" style="width:100%;"/>  
              <h1 class="centered" style="margin-top: -120px; padding-left: 10px">{{name}}</h1>
              
          </div>
         </div>  
    
         
         <div class="row" style="margin: 30px;  margin-top:100px; padding-top: 10px;">   
          <div class="col-md-6 col-sm-6 col-xs-12" style="border-right:1px solid #dddddd;">
           <div class="row">
           <div class="col-md-12 col-sm-12 col-xs-12">
               <div  class="col-md-1 col-sm-1 col-xs-1"> 
                <em class="zmdi zmdi-pin" style="font-size:62px !important; color: #0e7dce" ></em> 
              </div>
              <div class="col-md-11 col-sm-11 col-xs-11" style="padding-left: 40px;">
                <h4><strong>ADDRESS</strong></h4>
                <p class="address">{{address1}}</p>
                <p class="address">{{address2}}</p>
                <p class="address">{{city}}{{country}}{{zipcode}}</p>
              </div>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top: 30px">
                  <div  class="col-md-1 col-sm-1 col-xs-1">
                  <em class="zmdi zmdi-phone" style="font-size:62px !important; color: #0e7dce"  ></em>  
                   </div>
                   <div class="col-md-11 col-sm-11 col-xs-11" style="padding-left: 40px;">
                  <h4><strong>PHONE</strong></h4>
                  <p class="address" >{{phone}}</p>
                  </div>
              </div>
             <div class="col-md-12 col-sm-12 col-xs-12" style="margin-top: 30px">
                  <div  class="col-md-1 col-sm-1 col-xs-1">
                  <em class="zmdi zmdi-email" style="font-size:62px !important; color: #0e7dce"  ></em>
                </div>
                <div class="col-md-11 col-sm-11 col-xs-11" style="padding-left: 40px;">
                  <h4><strong>EMAIL</strong></h4>
                  <p class="address" style="color: #3973e6; cursor: pointer;" (click)='openMailBox(contactData?.email)' >{{email}}</p>
                </div>
              </div>
          </div> 
           </div>
           <div class="col-md-6 col-sm-6 col-xs-12 text-center"  >
               <img src="assets/img/contactme-icon.png" style="width:500px;border: 1px solid #ddd;border-radius: 4px; padding: 5px; " alt="">
          </div>
          </div>
          <br><br><br>
        </div></body></html>`; */